import __request__ from "routing/request";
export function backendConnection(JSONbody, requestOptions) {
  return __request__("POST", "/system/authentication/services/test/backend/connection", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function backendLogin(JSONbody, requestOptions) {
  return __request__("POST", "/system/authentication/services/test/backend/login", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
